export const ONLY_ONE_COUPON_ERROR = 'Coupon_Only_One';
export const INVALID_OR_EXPIRED_COUPON_ERROR = 'Coupon_Invalid';
export const COUPON_DOES_NOT_APPLY_ERROR = 'Coupon_Does_Not_Apply';
export const COUPON_ALREADY_USED_ERROR = 'Coupon_Already_Used';
export const COUPON_DOES_NOT_EXIST_ERROR = 'Coupon_Does_Not_Exist';
export const COUPON_HAS_BEEN_ALREADY_APPLIED_ERROR = 'Coupon_Has_Already_Been_Applied';
export const EMPTY_COUPON_CODE_ERROR = 'Empty_Coupon_Code';
